import React from "react";
import { useState } from "react";

interface ITab {
    label: string,
    content: React.ReactNode,
}

interface IMobileTabsProps {
    formTab?: React.ReactNode,
    treeTab: React.ReactNode,
    SDCA: React.ReactNode,
    comments: React.ReactNode,
    isEdit: boolean
}

const MobileTabs: React.FC<IMobileTabsProps> = ({formTab, treeTab, SDCA, comments, isEdit}) => {
    const [activeTab, setActiveTab] = useState<number>(0);
    const tabs: ITab[] = [
        {label: 'Форма', content: formTab},
        {label: 'Дерево', content: treeTab},
        {label: 'SDCA', content: SDCA},
        {label: 'Комментарии', content: comments},
    ];
    return (
        <div className="w-full h-full sticky top-[68px] z-60 bg-white">
            <div className="flex border-b border-gray-200 gap-[10px]" style={{display: isEdit ? "flex" : "none"}}>
                {
                    tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => setActiveTab(index)}
                            className={`py-[15px] text-sm font-medium ${
                            activeTab === index
                                ? "border-b-2 border-[#012169] text-[#012169]"
                                : "text-[#637381] hover:text-gray-700"
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))
                }
            </div>

            <div className="py-4 text-gray-700">
                {tabs[activeTab].content}
            </div>
        </div>
    );
}

export default MobileTabs;
